import React from "react";
import "./Seprator.css";

function Seprator() {
  return <div className="seprator--green"></div>;
}

export default Seprator;
